import { Component, Input, TemplateRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NgbModal, NgbModalModule, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'error-modal',
  standalone: true,
  templateUrl: './error-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgbModalModule]
})
export class ErrorModalComponent {
  @Input() message?: string;
  @Input() header?: string;

  @ViewChild('modalDiv') modalDiv!: TemplateRef<unknown>;
  modal?: NgbModalRef;

  constructor(private readonly modalService: NgbModal) {}

  open(message?: string): void {
    this.message = message || this.message;
    this.modal = this.modalService.open(this.modalDiv);
  }
}
